import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import HeaderDark from "./HeaderDark"
import FooterDark from "./Footer/indexDark"
import WeAreFooter from "./Footer/WeAreFooter"

const LayoutDark = ({ children }) => {
  const dataDark = useStaticQuery(graphql`
    query SiteTitleQueryDark {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div className="font-body subpixel-antialiased bg-primary text-white transform duration-500">
      <HeaderDark siteTitle={dataDark.site.siteMetadata?.title || `Title`} />
      <main>{children}</main>
      <WeAreFooter />
      <FooterDark />
    </div>
  )
}

LayoutDark.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutDark